import CookiePreferences from '@fs/zion-cookie-preferences'
import FooterWithProviders from './Footer'
import './locales'

const Footer = FooterWithProviders

export default Footer
export { FooterWithProviders }
export { default as CFFooter } from './CFFooter/CFFooter'
export { CookiePreferences }
